export const UNI_IMG = {
  "Pontificia Universidad Católica de Chile": { folder: "PUC", file: "1.png" },
  "Pontificia Universidad Católica de Valparaíso": { folder: "PUCV", file: "1.png" },
  "Universidad Alberto Hurtado": { folder: "UAH", file: "1.png" },
  "Universidad Andrés Bello": { folder: "UNAB", file: "1.png" },
  "Universidad Arturo Prat": { folder: "UNAP", file: "1.png" },
  "Universidad Austral de Chile": { folder: "UACH", file: "1.png" },
  "Universidad Bernardo O'Higgins": { folder: "UBO", file: "1.png" },
  "Universidad Católica de la Santísima Concepción": { folder: "UCSC", file: "1.png" },
  "Universidad Católica de Temuco": { folder: "UCT", file: "1.png" },
  "Universidad Católica del Maule": { folder: "UCM", file: "1.png" },
  "Universidad Católica del Norte": { folder: "UCN", file: "1.png" },
  "Universidad Central": { folder: "UCEN", file: "1.png" },
  "Universidad Católica Silva Henríquez": { folder: "UCSH", file: "1.png" },
  "Universidad de Atacama": { folder: "UDA", file: "1.png" },
  "Universidad de Chile": { folder: "UCH", file: "1.png" },
  "Universidad de Viña del Mar": { folder: "UVM", file: "1.png" },
  "Universidad de Concepción": { folder: "UDEC", file: "1.png" },
  "Universidad de la Frontera": { folder: "UFRO", file: "1.png" },
  "Universidad de La Serena": { folder: "USERENA", file: "1.png" },
  "Universidad de Las Américas": { folder: "UDLA", file: "1.png" },
  "Universidad del Bío-Bío": { folder: "UBB", file: "1.png" },
  "Universidad del Desarrollo": { folder: "UDD", file: "1.png" },
  "Universidad Diego Portales": { folder: "UDP", file: "1.png" },
  "Universidad de los Andes": { folder: "UANDES", file: "1.png" },
  "Universidad de Los Lagos": { folder: "ULA", file: "1.png" },
  "Universidad de Magallanes": { folder: "UMAG", file: "1.png" },
  "Universidad de O'Higgins": { folder: "UOH", file: "1.png" },
  "Universidad de Playa Ancha": { folder: "UPLA", file: "1.png" },
  "Universidad de Santiago de Chile": { folder: "USACH", file: "1.png" },
  "Universidad de Talca": { folder: "UT", file: "1.png" },
  "Universidad de Tarapacá": { folder: "UTA", file: "1.png" },
  "Universidad Finis Terrae": { folder: "UFT", file: "1.png" },
  "Universidad Metropolitana de Ciencias de la Educación": { folder: "UMCE", file: "1.png" },
  "Universidad San Sebastián": { folder: "USS", file: "1.png" },
  "Universidad Santo Tomás": { folder: "UST", file: "1.png" },
  "Universidad de Valparaíso": { folder: "UV", file: "1.png" },
  "Universidad Autónoma de Chile": { folder: "UA", file: "1.png" },
  "Universidad Mayor": { folder: "UMAYOR", file: "1.png" },
};

export const REGION_TO_CODE = {
  RM: { code: 13, name: "Región Metropolitana de Santiago" },
  I: { code: 1, name: "Región de Tarapacá" },
  II: { code: 2, name: "Región de Antofagasta" },
  III: { code: 3, name: "Región de Atacama" },
  IV: { code: 4, name: "Región de Coquimbo" },
  V: { code: 5, name: "Región de Valparaíso" },
  VI: { code: 6, name: "Región del Libertador General Bernardo O’Higgins" },
  VII: { code: 7, name: "Región del Maule" },
  VIII: { code: 8, name: "Región del Biobío" },
  IX: { code: 9, name: "Región de La Araucanía" },
  X: { code: 10, name: "Región de Los Lagos" },
  XI: { code: 11, name: "Región de Aysén del General Carlos Ibáñez del Campo" },
  XII: { code: 12, name: "Región de Magallanes y de la Antártica Chilena" },
  XIV: { code: 14, name: "Región de Los Ríos" },
  XV: { code: 15, name: "Región de Arica y Parinacota" },
  XVI: { code: 16, name: "Región de Ñuble" },
};

export const STANDARD_LABELS_BY_GROUP = {
  estandar_basica: {
    mat_basica_A: "Estándar A: Números y Operaciones",
    mat_basica_B: "Estándar B: Patrones y Álgebra",
    mat_basica_C: "Estándar C: Geometría y Medición",
    mat_basica_D: "Estándar D: Datos y Probabilidades",
    mat_basica_E: "Estándar E: Habilidades y Actitudes Matemáticas",
  },
  estandar_media: {
    mat_media_A: "Estándar A: Números y Álgebra",
    mat_media_B: "Estándar B: Geometría",
    mat_media_C: "Estándar C: Probabilidades y Estadística",
    mat_media_D: "Estándar D: Límites, Derivadas e integrales",
    mat_media_E: "Estándar E: Pensamiento computacional y programación",
    mat_media_F: "Estándar F: Habilidades y Actitudes Matemáticas",
  },
  estandar_lenguaje: {
    len_basica_A: "Estándar A: Lectura y escritura inicial",
    len_basica_B: "Estándar B: Lectura",
    len_basica_C: "Estándar C: Escritura",
    len_basica_D: "Estándar D: Comunicación oral",
    len_basica_E: "Estándar E: Literatura",
    len_basica_F: "Estándar F: Conocimiento y manejo de la lengua",
  },
};

export const PROGRAM_LABEL = {
  parvularia: "Pedagogía en Educación Parvularia",
  basica: "Pedagogía en Educación Básica",
  media: "Pedagogía en Educación Media",
  diferencial: "Pedagogía en Educación Diferencial",
  formacion_pedagogica: "Formación Pedagógica",
  postgrado: "Postgrado",
  other: "Otros Programas",
  "—": "—",
};

export const DISCIPLINE_LABEL = {
  matematica: "Matemática",
  lenguaje: "Lenguaje",
  parvularia: "Educación Parvularia",
  general: "General",
};

export const CATEGORY_LABEL = {
  redfid: "RedFID",
  externo: "Externo",
};

export const SUBCATEGORY_LABEL = {
  "encuentro-nacional": "Encuentro Nacional",
  "encuentro-virtual": "Encuentro Virtual",
  taller: "Taller",
  webinar: "Webinar",
  "reunion-virtual": "Reunión Virtual",
  "actividad-comite": "Actividad Comité",
  other: "Otro",
  otro: "Otro",
};

export const EMPTY_KEYS = new Set([
  "",
  "-",
  "—",
  "SIN INFORMACIÓN",
  "SIN INFORMACION",
  "N/A",
  "NA",
  "OTHER",
]);

export const ACTIVITY_LABEL = {
  taller: {
    singular: "Taller de Aprendizaje Profesional",
    plural: "Talleres de Aprendizaje Profesional",
  },
  "encuentro-nacional": {
    singular: "Encuentro Nacional de Formadores",
    plural: "Encuentros Nacionales de Formadores",
  },
  "encuentro-virtual": {
    singular: "Encuentro Telemático de Formadores",
    plural: "Encuentros Telemáticos de Formadores",
  },
  webinar: {
    singular: "Webinar",
    plural: "Webinars",
  },
  "actividad-comite": {
    singular: "Reunión del Comité RedFID",
    plural: "Reuniones del Comité RedFID",
  },
  "reunion-virtual": {
    singular: "Reunión Virtual RedFID",
    plural: "Reuniones Virtuales RedFID",
  },
  curso: {
    singular: "Curso",
    plural: "Cursos",
  },
  presentacion: {
    singular: "Presentación en Encuentro Nacional",
    plural: "Presentaciones en Encuentros Nacionales",
  },
  other: {
    singular: "Otra actividad",
    plural: "Otras actividades",
  },
};

export const LEVEL_DESCRIPTION = {
  novel: "Formadores que tienen hasta 5 años de experiencia en el rol.",
  intermedio: "Formadores que tienen hasta 11 años de experiencia en el rol.",
  experto: "Formadores que tienen 12 años o más de experiencia en el rol.",
};

export const LEVEL_REPORT_LABEL = {
  novel: "Novel (hasta 5 años)",
  intermedio: "Intermedio (hasta 11 años)",
  experto: "Experto (12 años o más)",
};

export const REPORT_ASSETS = {
  matematica: {
    header: "/assets/report/m_header.png",
    footer: "/assets/report/m_footer.png",
  },
  lenguaje: {
    header: "/assets/report/l_header.png",
    footer: "/assets/report/l_footer.png",
  },
};

export const REGION_ORDER_NORTH_TO_SOUTH = [
  15, 1, 2, 3, 4, 5, 13, 6, 7, 16, 8, 9, 14, 10, 11, 12,
];

export const COUNTRY_OPTIONS = [
  { value: "chile", label: "Chile" },
  { value: "extranjero", label: "Otros países" },
];

export const DISCIPLINE_OPTIONS = [
  { value: "general", label: "General" },
  { value: "matematica", label: "Matemática" },
  { value: "lenguaje", label: "Lenguaje" },
  { value: "parvularia", label: "Educación Parvularia" },
];

export const USER_REPORT_CONTENT_OPTIONS = [
  { value: "general", label: "General" },
  { value: "cursos", label: "Cursos" },
  { value: "encuentros", label: "Encuentros" },
  { value: "talleres", label: "Talleres" },
  { value: "webinars", label: "Webinars" },
  { value: "reuniones", label: "Reuniones" },
];

export const GENERAL_REPORT_CONTENT_OPTIONS = [
  { value: "general", label: "General" },
  { value: "universidades", label: "Universidades" },
  { value: "regiones", label: "Regiones" },
  { value: "carreras", label: "Carreras" },
];

export const REPORT_ACTIVITY_SECTIONS = [
  { key: "cursos", title: "Cursos", kind: "course", content: "cursos" },
  {
    key: "encuentrosNacionales",
    title: "Encuentros Nacionales",
    kind: "event",
    type: "encuentro",
    content: "encuentros",
  },
  {
    key: "presentaciones",
    title: "Presentaciones en encuentros",
    firstTitle: "Presentaciones en Encuentros Nacionales",
    kind: "list",
    content: "encuentros",
  },
  {
    key: "encuentrosTelematicos",
    title: "Encuentros Telemáticos",
    kind: "event",
    type: "encuentro",
    content: "encuentros",
  },
  {
    key: "talleres",
    title: "Talleres de Aprendizaje Profesional",
    kind: "event",
    type: "taller",
    content: "talleres",
  },
  {
    key: "talleresRelatados",
    title: "Talleres relatados",
    kind: "list",
    content: "talleres",
  },
  {
    key: "webinars",
    title: "Webinars",
    kind: "event",
    type: "webinar",
    content: "webinars",
  },
  {
    key: "reunionesComite",
    title: "Reuniones Comité",
    firstTitle: "Reuniones de comité",
    kind: "event",
    type: "reunion",
    content: "reuniones",
  },
  {
    key: "reunionesVirtuales",
    title: "Reuniones Virtuales",
    firstTitle: "Reuniones",
    kind: "event",
    type: "reunion",
    content: "reuniones",
  },
];

export const REPORT_SUMMARY_CARDS = [
  {
    key: "encuentros_nacionales_asistidos",
    singular: "Encuentro Nacional asistido",
    pluralLabel: "Encuentros Nacionales asistidos",
    content: "encuentros",
  },
  {
    key: "encuentros_telematicos_asistidos",
    singular: "Encuentro Telemático asistido",
    pluralLabel: "Encuentros Telemáticos asistidos",
    content: "encuentros",
  },
  {
    key: "presentaciones_realizadas",
    singular: "Presentación en encuentro",
    pluralLabel: "Presentaciones en encuentros",
    content: "encuentros",
  },
  {
    key: "talleres_asistidos",
    singular: "Taller de Aprendizaje Profesional asistido",
    pluralLabel: "Talleres de Aprendizaje Profesional asistidos",
    content: "talleres",
  },
  {
    key: "talleres_relatados",
    singular: "Taller relatado",
    pluralLabel: "Talleres relatados",
    content: "talleres",
  },
  {
    key: "webinars_asistidos",
    singular: "Webinar asistido",
    pluralLabel: "Webinars asistidos",
    content: "webinars",
  },
];

export const REPORT_ACTIVITY_YEAR_TITLE = {
  cursos: "Cursos realizados por año",
  encuentros: "Encuentros asistidos por año",
  talleres: "Talleres asistidos por año",
  webinars: "Webinars asistidos por año",
  reuniones: "Reuniones asistidas por año",
};

export const DASHBOARD_ROUTES = {
  participantes: "/participantes",
  formacion_niveles: "/formacion",
  formacion_grado: "/formacion",
  formacion_titulo: "/formacion",
  formacion_programas: "/formacion",
  universidades: "/universidades",
  region: "/regiones",
};
